import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';

const SearchComponent = ({
  name,
  setValues,
  value = '',
  onSearch,
  options_data = [],
  setselected_value,
  disabled,
  placeholder = 'Search...'
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [searchValue, setSearchValue] = useState(value);
  const [focusedIndex, setFocusedIndex] = useState(-1);

  const debounceTimeout = useRef(null);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  // Sync external value
  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  // Debounced search handler
  const onChangeData = (e) => {
    const val = e.target.value;
    setSearchValue(val);
    setValues(prev => ({ ...prev, [name]: val }));
    // setselected_value(null)

    if (onSearch) {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
      debounceTimeout.current = setTimeout(() => onSearch(val), 400);
    }
  };

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => clearTimeout(debounceTimeout.current);
  }, []);

  // Select handler
  const handleSelect = useCallback((item) => {
    setSearchValue(item.label || '');
    setValues(prev => ({ ...prev, [name]: item.value }));
    if (setselected_value) setselected_value(item.value);
    setDropdownVisible(false);
  }, [name, setValues, setselected_value]);

  // Keyboard navigation
  const handleKeyDown = (e) => {
    if (!options_data.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setFocusedIndex(prev => (prev + 1) % options_data.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setFocusedIndex(prev => (prev - 1 + options_data.length) % options_data.length);
    } else if (e.key === 'Enter' && focusedIndex >= 0) {
      e.preventDefault();
      handleSelect(options_data[focusedIndex]);
      inputRef.current?.blur();
    }
  };

  // Manage dropdown visibility and outside clicks
  useEffect(() => {
    const showDropdown = () => setDropdownVisible(searchValue.length > 0);

    const handleClickOutside = (e) => {
      if (!inputRef.current?.contains(e.target) && !dropdownRef.current?.contains(e.target)) {
        setDropdownVisible(false);
      }
    };

    const inputEl = inputRef.current;
    inputEl?.addEventListener('focus', showDropdown);
    inputEl?.addEventListener('keyup', showDropdown);
    document.addEventListener('click', handleClickOutside);

    return () => {
      inputEl?.removeEventListener('focus', showDropdown);
      inputEl?.removeEventListener('keyup', showDropdown);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [searchValue]);

  const clearSearch = () => {
    setSearchValue('');
    setValues(prev => ({ ...prev, [name]: '' }));
    setDropdownVisible(false);
  };

  return (
    <div className="app-search">
      <div className="position-relative">
        <Input
          type="text"
          className="form-control form-control-sm"
          placeholder={placeholder}
          value={searchValue}
          onChange={onChangeData}
          onKeyDown={handleKeyDown}
          autoComplete="off"
          innerRef={inputRef}
           disabled={disabled}
        />
        <span className="mdi mdi-magnify search-widget-icon" />
        {dropdownVisible && (
          <span
            className="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
            onClick={clearSearch}
          />
        )}
      </div>

      {dropdownVisible && (
        <div className="dropdown-menu dropdown-menu-lg show" ref={dropdownRef} style={{ maxHeight: '230px', overflow: 'auto' }}>
    
            {options_data.length > 0 ? (
              <>
                <div className="dropdown-header mt-2">
                  <h6 className="text-muted mb-1 text-uppercase">Search Results</h6>
                </div>
                {options_data.map((item, index) => (
                  <Link
                    key={index}
                    to="#"
                    className={`dropdown-item notify-item text-wrap ${index === focusedIndex ? 'bg-primary text-white' : ''}`}
                    onClick={() => handleSelect(item)}
                  >
                    <span>{item.label}</span>
                  </Link>
                ))}
              </>
            ) : (
              <div className="dropdown-header mt-2">
                <h6 className="text-muted mb-1 text-uppercase">No Results Found</h6>
              </div>
            )}
         
        </div>
      )}
    </div>
  );
};

export default SearchComponent;
